import { createSelector } from 'reselect';
import { addPercentOffFlagToSalePageSelector } from 'selectors/testTarget/offers/addPercentOffFlagToSalePage/addPercentOffFlagToSalePageSelector';

const showSelector = createSelector(addPercentOffFlagToSalePageSelector, addPercentOffFlagToSalePage => !!addPercentOffFlagToSalePage.show);

export { showSelector };
